import React, { useEffect, useState, useRef } from 'react';
import { Tooltip } from '@mui/material';
import tempIcon from '../../assets/icons/temp-icon.png';
import windIcon from '../../assets/icons/wind-icon.png';
import precipitationIcon from '../../assets/icons/precipitation-icon.png';
import cloudIcon from '../../assets/icons/cloud-icon-black.png';
import legendIcon from '../../assets/icons/info-icon.png';
import pressureIcon from '../../assets/icons/pressure-icon-black.png';
import humidityicon from '../../assets/icons/humidity-icon-black.png';
import layersIcon from '../../assets/icons/layers.png';
import MapSensorDataWidgets from './MapSensorDataWidgets/MapSensorDataWidgets';
import downArrowIcon from '../../assets/icons/down-arrow.png';
import './Widgets.scss';
import Legend from '../panels/Legend/Legend';

export default function MapWeatherWidgets(props) {
  const { map, satelliteLayers, setSatelliteLayers, selectedSatelliteLayer, setSelectedSatelliteLayer, satellites, flights } = props;

  const [layerVisibility, setLayerVisibility] = useState({
    'Layers - Temperature': false,
    'Layers - Humidity': false,
    'Layers - Wind': false,
    'Layers - Precipitation Intensity': false,
    'Layers - Accumulated Rain': false,
    'Layers - Atmospheric Pressure': false,
    'Layers - Clouds': false,
    'Source - AnimatedWind': true,
  });

  const [layersExpanded, setLayersExpanded] = useState(false);
  const [legendExpanded, setLegendExpanded] = useState(false);

  const initializeLayer = (layerId, sourceId, tiles) => {
    if (!map.current.getStyle().sources[sourceId]) {
      map.current.addSource(sourceId, {
        type: 'raster',
        tiles,
        tileSize: 256,
      });
      map.current.addLayer({
        id: layerId,
        type: 'raster',
        source: sourceId,
        minzoom: 0,
        maxzoom: 22,
        layout: {
          visibility: 'none',
        },
      });
    }
  };

  const toggleLayer = (layerId, sourceId, tiles) => {
    initializeLayer(layerId, sourceId, tiles);
    const currentVisibility = map.current.getLayoutProperty(layerId, 'visibility');
    const newVisibility = currentVisibility === 'visible' ? 'none' : 'visible';

    map.current.setLayoutProperty(layerId, 'visibility', newVisibility);

    setLayerVisibility((prev) => ({
      ...prev,
      [layerId]: newVisibility === 'visible',
    }));
  };

  const weatherWidgets = [
    {
      name: 'Temperature',
      layerId: 'Layers - Temperature',
      sourceId: 'Layers - Temperature',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/TA2/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=0.6&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: tempIcon,
      descripton:
        'Current, real-time air temperature overlay at a height of 2 meters on map.',
    },
    {
      name: 'Wind',
      layerId: 'Layers - Wind',
      sourceId: 'Layers - Wind',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/WND/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=1&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: windIcon,
      descripton:
        'Animated wind display with uniform speed, updated via a canvas overlay on map.',
    },
    {
      name: 'Humidity',
      layerId: 'Layers - Humidity',
      sourceId: 'Layers - Humidity',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/HRD0/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=0.4&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: humidityicon,
      descripton: 'Current, real-time relative humidity overlay on map.',
    },
    {
      name: 'Precipitation Intensity',
      layerId: 'Layers - Precipitation Intensity',
      sourceId: 'Layers - Precipitation Intensity',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/PR0/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=0.5&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: precipitationIcon,
      descripton: 'Current, real-time precipitation intensity overlay on map.',
    },
    // {
    //   name: 'Accumulated Rain',
    //   layerId: 'Layers - Accumulated Rain',
    //   sourceId: 'Layers - Accumulated Rain',
    //   tiles: [
    //     `https://maps.openweathermap.org/maps/2.0/weather/PAR0/{z}/{x}/{y}?date=${Math.floor(
    //       new Date().getTime() / 1000
    //     )}&opacity=1&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
    //   ],
    //   icon: precipitationIcon,
    //   descripton:
    //     'Current, real-time accumulated precipitation (rain) overlay on map.',
    // },
    {
      name: 'Atmospheric Pressure',
      layerId: 'Layers - Atmospheric Pressure',
      sourceId: 'Layers - Atmospheric Pressure',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/APM/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=0.5&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: pressureIcon,
      descripton: 'Current, real-time atmospheric pressure overlay on map.',
    },
    {
      name: 'Clouds',
      layerId: 'Layers - Clouds',
      sourceId: 'Layers - Clouds',
      tiles: [
        `https://maps.openweathermap.org/maps/2.0/weather/CL/{z}/{x}/{y}?date=${Math.floor(
          new Date().getTime() / 1000
        )}&opacity=1&fill_bound=true&appid=${process.env.REACT_APP_OPENWEATHER_KEY}`,
      ],
      icon: cloudIcon,
      descripton: 'Current, real-time cloudiness overlay on map.',
    },
  ];

  return (
    <>
    <div 
     className={`weather-widgets ${layersExpanded ? 'expanded' : ''}`}
     style={{ right: layersExpanded ? 6 : 4 }}
    >
        <Tooltip title='Expand or collaplse map layers.' arrow placement="left">
        <div
          className='weather-widgets-widget'
          onClick={() => {
            if (legendExpanded) setLegendExpanded(false);
            setLayersExpanded((prevState) => !prevState);
          }}
          
        >
           <img 
              src={downArrowIcon} 
              className='weather-widgets-widget-arrow'
              style={{
                  transition: 'transform 0.5s ease',
                  transform: layersExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  filter: 'invert(100%)'
              }}
            />
          <div
            className='weather-widgets-widget-title-show-hide'
            style={{ minWidth: layersExpanded ? 220 : 155,  maxWidth: layersExpanded ? 220 : 155 }}
          >
            {layersExpanded ? 'Hide Layers' : 'Layers'}
          </div>
          <div className="weather-widgets-widget-img-container">
            <img src={layersIcon} className="weather-widgets-widget-img" alt='Map Layers' />
          </div>
        </div>
      </Tooltip>
    {layersExpanded && 
    <>
    <MapSensorDataWidgets map={map} satelliteLayers={satelliteLayers} setSatelliteLayers={setSatelliteLayers} selectedSatelliteLayer={selectedSatelliteLayer} setSelectedSatelliteLayer={setSelectedSatelliteLayer} satellites={satellites} flights={flights}/>
    {weatherWidgets.map((widget, index) => (
      <Tooltip key={index} title={widget.descripton} arrow placement="left">
        <div
          className={
              layerVisibility[widget.layerId]
              ? 'weather-widgets-widget-active'
              : 'weather-widgets-widget'

          }
          onClick={() => {
            toggleLayer(widget.layerId, widget.sourceId, widget.tiles);
          }}
          
        >
          <div
            className={
              layerVisibility[widget.layerId]
              ? 'weather-widgets-widget-active-title'
              : 'weather-widgets-widget-title'
            }
          >
            {widget.name}
          </div>
          <div className="weather-widgets-widget-img-container">
            <img src={widget.icon} className="weather-widgets-widget-img" alt={widget.name} />
          </div>
        </div>
      </Tooltip>
    ))}
    </>}
  </div>
  <div className="weather-widgets" style={{ zIndex: 3, top: 145, right: legendExpanded ? 6 : 4, opacity: layersExpanded ? 0 : 1 }}>
    <Tooltip title='Map legend defining all data on interactive map.' arrow placement="left">
      <div
        className='weather-widgets-widget'
        onClick={() => {
          setLegendExpanded((prevState) => !prevState);
        }}
        
      >
        <img 
            src={downArrowIcon} 
            className='weather-widgets-widget-arrow'
            style={{
                transition: 'transform 0.5s ease',
                transform: legendExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                filter: 'invert(100%)'
            }}
          />
        <div
          className='weather-widgets-widget-title-show-hide'
          style={{ minWidth: 155,  maxWidth: 155 }}
        >
          {legendExpanded ? 'Hide Legend' : 'Legend'}
        </div>
        <div className="weather-widgets-widget-img-container">
          <img src={legendIcon} className="weather-widgets-widget-img" alt='Map Layers' />
        </div>
      </div>
    </Tooltip>
    {legendExpanded && <Legend /> }
    </div>
  </>
  );
}
